import { getDisplayCurrency, subscribeDisplayCurrencyChanged } from '@experience/core-display-currency-lib';
import { normalizeDisplayCurrencyIso } from '@/shared/lib/normalizeDisplayCurrencyIso';
import { onScopeDispose } from 'vue';

type PriceFilterValue = Array<number | null>;

type PriceFilterStore = {
  state: { price: PriceFilterValue };
  searchState: { price: PriceFilterValue };
  search: () => void;
};

/** Сбрасывает черновик фильтра цены в модалке. */
export function clearDraftPriceFilterState(state: { price: PriceFilterValue }): void {
  if (!state.price.some((value) => value !== null)) {
    return;
  }

  state.price = [null, null];
}

/** Сбрасывает фильтр цены в черновике и в применённом состоянии. */
export function clearPriceFilterState(
  state: { price: PriceFilterValue },
  searchState: { price: PriceFilterValue },
): void {
  state.price = [null, null];
  searchState.price = [null, null];
}

/**
 * При смене валюты в модалке сбрасывает черновик цены.
 * Если выбрана уже применённая валюта — восстанавливает диапазон из searchState.
 */
export function syncDraftPriceFilterStateOnDisplayCurrencyChange(
  isoCode: string,
  state: { price: PriceFilterValue },
  searchState: { price: PriceFilterValue },
): void {
  const nextIso = normalizeDisplayCurrencyIso(isoCode);
  const appliedIso = normalizeDisplayCurrencyIso(getDisplayCurrency());

  if (nextIso === appliedIso) {
    state.price = [...searchState.price];

    return;
  }

  clearDraftPriceFilterState(state);
}

/** Сбрасывает применённый фильтр цены при смене валюты вне модалки (host app). */
export function useClearPriceFilterOnCommittedDisplayCurrencyChange(store: PriceFilterStore): void {
  let lastKnownDisplayCurrency = normalizeDisplayCurrencyIso(getDisplayCurrency());

  onScopeDispose(
    subscribeDisplayCurrencyChanged((currency) => {
      const normalized = normalizeDisplayCurrencyIso(currency);

      if (!normalized || normalized === lastKnownDisplayCurrency) {
        return;
      }

      lastKnownDisplayCurrency = normalized;

      if (!store.searchState.price.some((value) => value !== null)) {
        return;
      }

      clearPriceFilterState(store.state, store.searchState);
      store.search();
    }),
  );
}
